// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__Wnl_C","text":"SelectPayment_text__3Jswk","title":"SelectPayment_title__1vBtM","btn":"SelectPayment_btn__1eeiP"};